import { generic_server, private_server } from '../../utils/axios';
import { fileNameByUrl, fileTypeByUrl } from '../../utils/files';


const useUser = () => {   

    const actions = {
        onGetAll: async(params) => {
            let result = {
                data:[], 
                count:0
            }
            const request = await private_server.get('/users/all', {params:params})
            result.data = request.data.data.users
            result.count = request.data.data.count
            return result
        },
        onGet: async(id) => {
            let result = null
            const request = await private_server.get(`/users/${id}`)
            result = request.data.data.user
            return result
        },
        onAdd: async(data2send) => {
            let result = null
            const request = await private_server.post('/users', data2send)
            result = request.data.data.user_id
            return result
        },
        onEdit: async(id, data2send) => {
            await private_server.patch(`/users/${id}`, data2send)
        },
        onUpdatePassword: async(data2send) => {
            await private_server.post(`/users/me/passwordchange`, data2send)
        },
        onDelete: async(id) => {
            await private_server.delete(`/users/${id}`)
        },
        onUpdatePicture: async(id, file) => {
            console.log('Mi archivo', file)
            const fType = fileTypeByUrl(file.name)
            const data2send = {type:fType}
            const options = {headers: {'Content-Type': file.type}}
            const response = await private_server.post(`/users/${id}/image`, data2send)
            console.log(response.data.data)
            await generic_server.put(response.data.data.upload_url, file, options);
        },

    }

    return {
        actions
    }
}
 
export default useUser;